import { useSelector } from "react-redux";

export const useInstallation = () => {
    return useSelector((state) => state.installation);
};
